import { ACTOR_ID_HEADER_KEY, PAYMENT_SERVICE_BASE_URL } from "constants";
import apiClient from "utils/apiClient";

const PARTNERS_BASE = `${PAYMENT_SERVICE_BASE_URL}/api/v1/business-growth-partners`;
const ORGANIZATION_ID_FIELD = `business${"Entity"}Id`;
const PRODUCT_CODE = "OLIVEEB_OVACUS_SERVICE";

const actorHeaders = (actorId) =>
  actorId ? { [ACTOR_ID_HEADER_KEY]: actorId } : {};

const pageResult = (data) => {
  if (Array.isArray(data)) {
    return {
      content: data,
      totalElements: data.length,
      number: 0,
      size: data.length,
    };
  }

  return data || { content: [], totalElements: 0, number: 0, size: 0 };
};

const normalizePartnerPayload = (payload = {}, { includeStatus = false } = {}) => {
  const partnerType = payload.partnerType || "USER";
  return {
    partnerType,
    displayName: payload.displayName || undefined,
    email: payload.email || undefined,
    userId: partnerType === "USER" ? payload.userId || undefined : undefined,
    [ORGANIZATION_ID_FIELD]:
      partnerType === "ORGANIZATION" ? payload.organizationId || undefined : undefined,
    ...(includeStatus ? { status: payload.status || undefined } : {}),
  };
};

export const partnersService = {
  list: async ({ page = 0, size = 20, sort = "createdAt,desc" } = {}) => {
    const response = await apiClient.get(PARTNERS_BASE, {
      params: { page, size, sort },
    });
    return pageResult(response.data);
  },

  create: async ({ actorId, payload } = {}) => {
    const response = await apiClient.post(
      PARTNERS_BASE,
      normalizePartnerPayload(payload),
      { headers: actorHeaders(actorId) },
    );
    return response.data || {};
  },

  update: async ({ actorId, id, payload } = {}) => {
    const response = await apiClient.patch(
      `${PARTNERS_BASE}/${id}`,
      normalizePartnerPayload(payload, { includeStatus: true }),
      { headers: actorHeaders(actorId) },
    );
    return response.data || {};
  },

  cancel: async ({ actorId, id } = {}) => {
    const response = await apiClient.patch(
      `${PARTNERS_BASE}/${id}/cancel`,
      undefined,
      { headers: actorHeaders(actorId) },
    );
    return response.data || {};
  },

  listCommissions: async ({
    businessGrowthPartnerId,
    chargeItemCode,
    product = PRODUCT_CODE,
    page = 0,
    size = 20,
    sort = "createdAt,desc",
  } = {}) => {
    const response = await apiClient.get(`${PARTNERS_BASE}/commissions`, {
      params: {
        businessGrowthPartnerId: businessGrowthPartnerId || undefined,
        chargeItemCode: chargeItemCode || undefined,
        product: product || undefined,
        page,
        size,
        sort,
      },
    });
    return pageResult(response.data);
  },

  listCommissionRates: async ({
    chargeItemCode,
    product = PRODUCT_CODE,
    page = 0,
    size = 100,
    sort = "createdAt,desc",
  } = {}) => {
    const response = await apiClient.get(`${PARTNERS_BASE}/commission-rates`, {
      params: {
        chargeItemCode: chargeItemCode || undefined,
        product: product || undefined,
        page,
        size,
        sort,
      },
    });
    return pageResult(response.data);
  },
};

export default partnersService;
